import { render, staticRenderFns } from "./PoliticaSeguranca.vue?vue&type=template&id=7995b0dc"
import script from "./PoliticaSeguranca.vue?vue&type=script&lang=js"
export * from "./PoliticaSeguranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports